import React, { useEffect } from "react";

import { IOS_APP_STORE_URL } from "../utils/constants/appLinks";

const DeliveryAppOpen = () => {
  useEffect(() => {
    window.location.replace(IOS_APP_STORE_URL);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FDF8F7] px-6 text-center">
      <p className="text-sm font-medium text-slate-700">
        Opening App Store...
      </p>
    </div>
  );
};

export default DeliveryAppOpen;
